import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicBookingWidgetIndex } from '@/pages/self-booking-public-widget/PublicBookingWidgetIndex';

const searchSchema = z.object({
	bookingId: z.string().optional(),
});

export const Route = createFileRoute('/book-meeting/$slug')({
	validateSearch: searchSchema,
	component: PublicBookingWidgetIndex,
});
